"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_1 = tslib_1.__importDefault(require("lodash"));
var memoizedPartial = function (fn) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var memoizedPartialFn;
    if (fn._memoizeCache) {
        memoizedPartialFn = fn._memoizeCache.get(args);
    }
    else {
        fn._memoizeCache = new WeakMap();
    }
    if (!memoizedPartialFn) {
        // @ts-expect-error
        memoizedPartialFn = lodash_1.default.partial.apply(lodash_1.default, tslib_1.__spreadArray([fn], tslib_1.__read(args), false));
        fn._memoizeCache.set(args, memoizedPartialFn);
    }
    return memoizedPartialFn;
};
exports.default = memoizedPartial;
//# sourceMappingURL=memoized-partial.js.map